import template from './paylocity-payroll.html';
import controller from './paylocity-payroll.controller';

let paylocityPayrollComponent = {
  restrict: 'E',
  template,
  controller
};

export default paylocityPayrollComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/payroll/paylocity-payroll.component.js